import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthenticationService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.authenticationService.isIdentityRefreshRequest(request.url)) {
            return next.handle(request);
        }

        return from(this.authenticationService.getValidAccessToken()).pipe(
            switchMap((token) => {
                const headers: Record<string, string> = {};
                if (token) {
                    headers.Authorization = `Bearer ${token}`;
                    const orgId = this.authenticationService.resolveActiveOrganizationId();
                    if (
                        orgId &&
                        this.authenticationService.isIdentityAccessToken(token)
                    ) {
                        headers['X-Organization-Id'] = orgId;
                    }
                }
                if (Object.keys(headers).length) {
                    request = request.clone({ setHeaders: headers });
                }
                return next.handle(request);
            })
        );
    }
}
